import * as p from '@clack/prompts'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptConfirm } from '../schema-prompts/prompt-confirm.js'
import { promptField } from '../schema-prompts/prompt-field.js'
import { promptSelectValue } from '../schema-prompts/prompt-select-value.js'
import { createFieldPromptOptions } from './create-field-prompt-options.js'

export async function promptTabSlotFields(
  kind: 'entity' | 'single',
  schemasDir: string,
  titleField: SchemaField | undefined
): Promise<{ main: SchemaField[]; sidebar: SchemaField[] }> {
  const main: SchemaField[] = titleField ? [titleField] : []
  const sidebar: SchemaField[] = []

  while (true) {
    const hasFields = main.length + sidebar.length > 0
    const addField = await promptConfirm(
      CREATE_PROMPT_CONTEXT,
      hasFields ? 'Add another tab child field?' : 'Add a tab child field?',
      !hasFields
    )

    if (!addField) {
      if (!hasFields) {
        p.log.warn('Tabs need at least one child field.')
        continue
      }
      return { main, sidebar }
    }

    const slot = await promptSelectValue(
      CREATE_PROMPT_CONTEXT,
      'Child field slot',
      [
        { value: 'main', label: 'main' },
        { value: 'sidebar', label: 'sidebar' }
      ],
      'main'
    )
    const child = (await promptField(
      CREATE_PROMPT_CONTEXT,
      kind,
      schemasDir,
      'schema',
      1,
      createFieldPromptOptions([...main, ...sidebar])
    )) as SchemaField
    if (slot === 'sidebar') {
      sidebar.push(child)
    } else {
      main.push(child)
    }
  }
}
